import { type ScreenshareEventData } from '../../hooks/useScreenshareState/screenshareState.types';

export enum ScreenshareTransition {
  INITIALIZE = 'INITIALIZE',
  INIT_FAILED = 'INIT_FAILED',
  STARTING_STREAM = 'STARTING_STREAM',
  LOADING_STREAM_DONE = 'LOADING_STREAM_DONE',
  STOP_SCREENSHARE = 'STOP_SCREENSHARE',
  SEND_SCREENSHARE_REQUEST = 'SEND_SCREENSHARE_REQUEST',
  RECEIVED_SCREENSHARE_REQUEST = 'RECEIVED_SCREENSHARE_REQUEST',
  ACCEPT_SCREENSHARE_REQUEST = 'ACCEPT_SCREENSHARE_REQUEST',
  REJECT_SCREENSHARE_REQUEST = 'REJECT_SCREENSHARE_REQUEST',
  CANCEL_SCREENSHARE_REQUEST = 'CANCEL_SCREENSHARE_REQUEST',
  PERMISSIONS_ERROR = 'PERMISSIONS_ERROR',
}

export enum ScreenshareState {
  NotStarted = 'NotStarted',
  ChoosingWindowToShare = 'ChoosingWindowToShare',
  LoadingStream = 'LoadingStream',
  LoadingRemoteStream = 'LoadingRemoteStream',
  LoadingLocalStream = 'LoadingLocalStream',
  InProgress = 'InProgress',
  // Provider can request a  from the patient
  RequestReceived = 'RequestReceived',
  WaitingForRequestResponse = 'WaitingForRequestResponse',
  RequestRejected = 'RequestRejected',
  RequestCancelled = 'RequestCancelled',
  // Error states
  Error = 'Error',
  InitializationError = 'InitializationError',
  PermissionsError = 'PermissionsError',
}

export type ScreensharePayload = {
  type: ScreenshareTransition;
  eventData?: unknown;
};

export type ScreenshareInitialState = {
  screenshareState: ScreenshareStates;
  currentRequestedMemberId: string | undefined;
  currentEventData: ScreenshareEventData | undefined;
  startedAt: number | undefined;
};

export type ScreenshareStates = `${ScreenshareState}`;

export type ScreenshareEvents =
  | { type: 'INITIALIZE' }
  | { type: 'INIT_FAILED' }
  | { type: 'STARTING_STREAM' }
  | { type: 'LOADING_STREAM_DONE' }
  | { type: 'STOP_SCREENSHARE' }
  | { type: 'SEND_SCREENSHARE_REQUEST' }
  | { type: 'RECEIVED_SCREENSHARE_REQUEST' }
  | { type: 'ACCEPT_SCREENSHARE_REQUEST' }
  | { type: 'REJECT_SCREENSHARE_REQUEST' }
  | { type: 'CANCEL_SCREENSHARE_REQUEST' }
  | { type: 'RESET' }
  | { type: 'PERMISSIONS_ERROR' };

export type ScreenshareStoppedReason =
  | 'PROVIDER_STOPPED_OWN'
  | 'PATIENT_STOPPED_OWN'
  | 'PROVIDER_STOPPED_PATIENT'
  | 'DO_NOT_TRACK';
